import { useState, useEffect } from "react";
import LandingPage from "./LandingPage";
import MapLayout from "./MapLayout";
import { track } from "./analytics/analytics";

export default function GetAQuote() {
  const [step, setStep] = useState(1);
  const [tripType, setTripType] = useState("");

  const onNext = () => {
    setStep(2);
    track("Selected Trip Type", { tripType });
  };

  useEffect(() => {
    const stored = sessionStorage.getItem("miniGetAQuoteData");

    if (!stored) return;

    try {
      const data = JSON.parse(stored);

      setTripType(data.tripType);
      setStep(data.isMobile ? 2 : 3);
    } catch (err) {
      console.error("Failed to parse session data", err);
    }
  }, []);

  return (
    <>
      {step === 1 && (
        <LandingPage
          step={step}
          onNext={() => onNext()}
          tripType={tripType}
          setTripType={setTripType}
        />
      )}

      {step >= 2 && (
        <MapLayout
          step={step}
          tripType={tripType}
          setTripType={setTripType}
          onNext={() => setStep(step + 1)}
          onBack={() => setStep(step - 1)}
        />
      )}
    </>
  );
}
